import { render, staticRenderFns } from "./logistic-info-table.vue?vue&type=template&id=b79cf8e6&scoped=true"
import script from "./logistic-info-table.vue?vue&type=script&lang=js"
export * from "./logistic-info-table.vue?vue&type=script&lang=js"
import style0 from "./logistic-info-table.vue?vue&type=style&index=0&id=b79cf8e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79cf8e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b79cf8e6')) {
      api.createRecord('b79cf8e6', component.options)
    } else {
      api.reload('b79cf8e6', component.options)
    }
    module.hot.accept("./logistic-info-table.vue?vue&type=template&id=b79cf8e6&scoped=true", function () {
      api.rerender('b79cf8e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/logistic-info-table.vue"
export default component.exports